import React, { useEffect, useState } from 'react';
import { Table, Card, Spin} from 'antd';
import {  DownloadOutlined } from '@ant-design/icons';
import utils from '../utils/index'
import { CSVLink } from "react-csv";
const header = [
  { label: "CL_code", key: "CL_code" },
  { label: "Date", key: "Date" },
  { label: "AbsentRMs", key: "AbsentRMs" }
];
const token = localStorage.getItem("token");
const TableData = ({ data }) => {
  let date = new Date();
  const today = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  const time = `${date.getHours()}:${date.getMinutes()}`

  let csvRport = {
    filename: `"Absent RMs"+${today}+${time}`,
    headers: header,
    data: data
  }

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState(data);
  const columns = [
    {
      title: "CLcode",
      dataIndex: "CL_code",
      key: "CL_code",
      fixed: "left",
      sorter: (a, b) => utils.antdTableSorter(a, b, 'CL_code')
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      fixed: "left",
      sorter: (a, b) => utils.antdTableSorter(a, b, 'Date')
    },
    {
      title: "Absent RMs",
      dataIndex: "AbsentRMs",
      key: "AbsentRMs",
      fixed: "left",
      sorter: (a, b) => utils.antdTableSorter(a, b, 'AbsentRMs')
    },
  ];

  useEffect(() => {
    async function fatchData() {
      data.map((obj, index) => { obj.index = index })
      setTableData(data);
      setLoading(false)
    }
    fatchData();
  }, [data])

  return (
    loading ? (<Spin tip='loading'></Spin>) :
      <>
        <Card title="Absent RMs"
          style={{ 'fontSize': '5px' }}
          extra={
            <CSVLink {...csvRport}>
              <DownloadOutlined style={{ 'fontSize': 30 }} />
            </CSVLink>
          }>
          <Table xs={24} sm={50} md={50}
            columns={columns}
            dataSource={tableData}
            rowKey='index'
          />
        </Card>

      </>
  )
}

export default TableData